import InitialRecommends from '@app/domains/home/containers/HomeRecommendedNovels/InitialRecommends';
import RelatedRecommends from '@app/domains/home/containers/HomeRecommendedNovels/RelatedRecommends';
import useRecommendations from '@app/domains/home/hooks/useRecommendations';
import { useAuth } from '@app/libs/auth';

export default function HomeRecommendedNovels() {
    const { init } = useAuth();

    const {
        relatedContent,
        contents = Array<undefined>(5).fill(undefined),
        contentsWithGenre = Array<undefined>(5).fill(undefined),
        isSuccess,
    } = useRecommendations({ contentType: 'novel' });

    const isLoading = !init || !isSuccess;

    return relatedContent ? (
        <RelatedRecommends relatedContent={relatedContent} contents={contents} isLoading={isLoading} />
    ) : (
        <InitialRecommends contentsWithGenre={contentsWithGenre} isLoading={isLoading} />
    );
}
